import React from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';

const FilterBar = ({ filters, onFilterChange }) => {
  const dealSizeOptions = [
    { value: 'all', label: 'All Deal Sizes' },
    { value: 'small', label: 'Small (<$500k)' },
    { value: 'medium', label: 'Medium ($500k-$1M)' },
    { value: 'large', label: 'Large (>$1M)' }
  ];

  const industryOptions = [
    { value: 'all', label: 'All Industries' },
    { value: 'Technology', label: 'Technology' },
    { value: 'Construction', label: 'Construction' },
    { value: 'Real Estate', label: 'Real Estate' },
    { value: 'Finance', label: 'Finance' }
  ];

  const assignedToOptions = [
    { value: 'all', label: 'All Sales Reps' },
    { value: 'Admin User', label: 'Admin User' }
  ];

  const timeInStageOptions = [
    { value: 'all', label: 'All Time Ranges' },
    { value: 'new', label: 'New (0-3 days)' },
    { value: 'active', label: 'Active (4-14 days)' },
    { value: 'stale', label: 'Stale (>14 days)' }
  ];

  const handleFilterChange = (key, value) => {
    onFilterChange({
      ...filters,
      [key]: value
    });
  };

  const activeFilterCount = Object.values(filters)?.filter(v => v !== 'all')?.length;

  return (
    <div className="bg-card rounded-2xl border border-border p-4 mb-6">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="Filter" size={20} className="text-primary" />
        <h3 className="font-semibold text-foreground">Filters</h3>
        {activeFilterCount > 0 && (
          <span className="text-xs bg-primary/10 text-primary px-2 py-1 rounded-full">
            {activeFilterCount} active
          </span>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <Select
          label="Deal Size"
          options={dealSizeOptions}
          value={filters?.dealSize}
          onChange={(value) => handleFilterChange('dealSize', value)}
        />
        <Select
          label="Industry"
          options={industryOptions}
          value={filters?.industry}
          onChange={(value) => handleFilterChange('industry', value)}
        />
        <Select
          label="Assigned To"
          options={assignedToOptions}
          value={filters?.assignedTo}
          onChange={(value) => handleFilterChange('assignedTo', value)}
        />
        <Select
          label="Time in Stage"
          options={timeInStageOptions}
          value={filters?.timeInStage}
          onChange={(value) => handleFilterChange('timeInStage', value)}
        />
      </div>
    </div>
  );
};

export default FilterBar;